import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Section from '../Section/Section';
import {
  getPopularStreamersList,
  isBlockBlockedProfile,
  authPopup,
} from '../../redux/actions/auth';
import BlockUnblockModal from '../BlockUnblockModal';

const StreamerListSection = ({ ...otherProps }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { popularStreamers, token } = auth;
  const [isTriggerBlockModal, setTriggerBlockModal] = useState(false);
  const [blockType, setBlockType] = useState('block');
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    dispatch(getPopularStreamersList());
  }, [dispatch]);

  if (!popularStreamers || !popularStreamers.length) return null;

  const checkBlockUnblock = async (data) => {
    if (!token) {
      dispatch(authPopup.show());
      return true;
    }
    const res = await dispatch(
      isBlockBlockedProfile(data.profile.accountId, data.profile.id)
    );
    if (res?.data?.status === 'BLOCKING') {
      setProfile(data.profile);
      setBlockType('unblock');
      setTriggerBlockModal(true);
      return true;
    }
    if (res?.data?.status === 'BLOCKED') {
      setProfile(data.profile);
      setTriggerBlockModal(true);
      setBlockType('access');
      return true;
    }

    return false;
  };

  const onCloseBlockModal = (type) => {
    if (type === 'cancel') {
      setTriggerBlockModal(false);
      setProfile(null);
    }
    setTriggerBlockModal(false);
  };

  return (
    <div style={{ padding: '0px 0.5rem' }}>
      <Section
        {...otherProps}
        sectionData={popularStreamers}
        topSection={true}
        allowSeeAll={false}
        itemType='popular-streamers'
        checkBlockUnblock={checkBlockUnblock}
      />

      {profile && (
        <BlockUnblockModal
          profile={profile}
          blockType={blockType}
          isTriggered={isTriggerBlockModal}
          onClose={onCloseBlockModal}
          checkType='profile'
        />
      )}
    </div>
  );
};

export default StreamerListSection;
